import { getUrlParams } from './url';

export const createUrl = (url: string, params?: Record<string, string>) => {
  const searchParams = params ? new URLSearchParams(params).toString() : '';
  return searchParams ? `${url}?${searchParams}` : url;
};

export const navigate = (path: string, params?: Record<string, string>) => {
  let route = window.location.origin;
  if (path.startsWith('/')) {
    route += path;
  } else {
    route += `/${path}`;
  }
  const urlParams = getUrlParams();
  const finalParams = {
    ...urlParams,
    ...params,
  };
  window.location.href = createUrl(route, finalParams);
};
